import { User } from 'app/classes/user';
import { Group } from 'app/group-management/models/group.model';
import { PlanMetadata } from 'fitforce-document-sync';
import { GroupTrainingLoad } from '../models/group-training-load.model';
import { PftCftObservationDocument } from '../models/individual-pft-cft-score.model';
import { IndividualTrainingLoad } from '../models/individual-training-load.model';
import { PlanTrainingLoad } from '../models/plan-training-load.model';
import { TabState } from '../models/tab-state.model';
import { TrainingLoadAnalysis } from '../models/training-load-analysis.model';
import { TrainingLoadParams, TrainingLoadType } from '../models/training-load-params.model';

export class GetGroups {
  static readonly type = '[Explore] GetGroups';
}

export class GetMarines {
  static readonly type = '[Explore] GetMarines';
  constructor(public groups: Group[]) {}
}

export class GetGroupsSuccess {
  static readonly type = '[Explore] GetGroupsSuccess';
  constructor(public groups: Group[]) {}
}

export class GetGroupsFailed {
  static readonly type = '[Explore] GetGroupsFailed';
  constructor(public reason: any) {}
}

export class SelectMarine {
  static readonly type = '[Explore] SelectMarine';
  constructor(public uuid: string) {}
}

export class SelectPlan {
  static readonly type = '[Explore] SelectPlan';
  constructor(public plan: PlanMetadata) {}
}

export class SelectGroup {
  static readonly type = '[Explore] SelectGroup';
  constructor(public group: Group) {}
}

export class GetGroupTrainingLoads {
  static readonly type = '[Explore] GetGroupTrainingLoads';
  constructor(public group: Group, public startDate: Date, public endDate: Date) {}
}

export class GetGroupTrainingLoadsSuccess {
  static readonly type = '[Explore] GetGroupTrainingLoadsSuccess';
  constructor(public trainingLoads: GroupTrainingLoad[]) {}
}

export class GetGroupTrainingLoadsFailed {
  static readonly type = '[Explore] GetGroupTrainingLoadsFailed';
  constructor(public reason: any) {}
}

export class GetIndividualTrainingLoads {
  static readonly type = '[Explore] GetIndividualTrainingLoads';
  constructor(public marine: User, public startDate: Date, public endDate: Date) {}
}

export class GetIndividualTrainingLoadsSuccess {
  static readonly type = '[Explore] GetIndividualTrainingLoadsSuccess';
  constructor(public trainingLoads: IndividualTrainingLoad[]) {}
}

export class GetIndividualTrainingLoadsFailed {
  static readonly type = '[Explore] GetIndividualTrainingLoadsFailed';
  constructor(public reason: any) {}
}
export class GetIndividualTrainingLoadAnalyses {
  static readonly type = '[Explore] GetIndividualTrainingLoadAnalyses';
  constructor(public marine: User, public startDate: Date, public endDate: Date) {}
}

export class GetIndividualTrainingLoadAnalysesSuccess {
  static readonly type = '[Explore] GetIndividualTrainingLoadAnalysesSuccess';
  constructor(public trainingLoads: TrainingLoadAnalysis[]) {}
}

export class GetIndividualTrainingLoadAnalysesFailed {
  static readonly type = '[Explore] GetIndividualTrainingLoadAnalysesFailed';
  constructor(public reason: any) {}
}

export class GetPlanTrainingLoads {
  static readonly type = '[Explore] GetPlanTrainingLoads';
  constructor(public plan: PlanMetadata, public startDate: Date, public endDate: Date) {}
}

export class GetPlanTrainingLoadsSuccess {
  static readonly type = '[Explore] GetPlanTrainingLoadsSuccess';
  constructor(public trainingLoads: PlanTrainingLoad[]) {}
}

export class GetPlanTrainingLoadsFailed {
  static readonly type = '[Explore] GetPlanTrainingLoadsFailed';
  constructor(public reason: any) {}
}

// TODO: change marine to plan
export class GetPlanTrainingLoadAnalyses {
  static readonly type = '[Explore] GetPlanTrainingLoadAnalyses';
  constructor(public plan: PlanMetadata, public startDate: Date, public endDate: Date) {}
}

export class GetPlanTrainingLoadAnalysesSuccess {
  static readonly type = '[Explore] GetPlanTrainingLoadAnalysesSuccess';
  constructor(public trainingLoads: TrainingLoadAnalysis[]) {}
}

export class GetPlanTrainingLoadAnalysesFailed {
  static readonly type = '[Explore] GetPlanTrainingLoadAnalysesFailed';
  constructor(public reason: any) {}
}

export class GetGroupTrainingLoadAnalyses {
  static readonly type = '[Explore] GetGroupTrainingLoadAnalyses';
  constructor(public group: Group, public startDate: Date, public endDate: Date) {}
}

export class GetGroupTrainingLoadAnalysesSuccess {
  static readonly type = '[Explore] GetGroupTrainingLoadAnalysesSuccess';
  constructor(public trainingLoads: TrainingLoadAnalysis[]) {}
}

export class GetGroupTrainingLoadAnalysesFailed {
  static readonly type = '[Explore] GetGroupTrainingLoadAnalysesFailed';
  constructor(public reason: any) {}
}

export class GetPlansPublishedToGroup {
  static readonly type = '[Explore] GetPlansPublishedToGroup';
  constructor(public groupUUID: string) {}
}

export class GetPlansPublishedToGroupSuccess {
  static readonly type = '[Explore] GetPlansPublishedToGroupSuccess';
  constructor(public plans: PlanMetadata[]) {}
}

export class GetPlansPublishedToAllGroups {
  static readonly type = '[Explore] GetPlansPublishedToAllGroups';
  constructor(public groupUUIDs: string[]) {}
}

export class GetPlansPublishedToAllGroupsSuccess {
  static readonly type = '[Explore] GetPlansPublishedToGroupSuccess';
  constructor(public plans: PlanMetadata[]) {}
}

export class GetPlansPublishedToGroupFailed {
  static readonly type = '[Explore] GetPlansPublishedToGroupFailed';
  constructor(public reason: any) {}
}

export class GetUserData {
  static readonly type = '[Explore] GetUserData';
  constructor(public marineUUID: string) {}
}

export class GetUserDataSuccess {
  static readonly type = '[Explore] GetUserDataSuccess';
  constructor(public marine: User) {}
}

export class SetTabState {
  static readonly type = '[Explore] SetTabState';
  constructor(public tabState: TabState) {}
}

export class GetTrainingLoadParams {
  static readonly type = '[Explore] GetTrainingLoadParams';
  constructor(public UUID: string, public type: TrainingLoadType) {}
}

export class GetTrainingLoadParamsSuccess {
  static readonly type = '[Explore] GetTrainingLoadParamsSuccess';
  constructor(public trainingLoadParams: TrainingLoadParams) {}
}

export class ResetExploreState {
  static readonly type = '[Explore] ResetExploreState';
  constructor() {}
}

/* PFT document actions */
export class GetPftDocument {
  static readonly type = '[Explore] GetPftDocument';
  constructor(public uuid: string) {}
}

export class GetPftDocumentSuccess {
  static readonly type = '[Explore] GetPftDocumentSuccess';
  constructor(public pftDocument: PftCftObservationDocument) {}
}

export class GetPftDocuments {
  static readonly type = '[Explore] GetPftDocuments';
  constructor(public groupUuid: string) {}
}

export class GetPftDocumentsSuccess {
  static readonly type = '[Explore] GetPftDocumentsSuccess';
  constructor(public pftDocuments: PftCftObservationDocument[]) {}
}

export class GetIndividualPftScores {
  static readonly type = '[Explore] GetIndividualPftScores';
  constructor(public marine: User) {}
}

export class GetIndividualPftScoresSuccess {
  static readonly type = '[Explore] GetIndividualPftScoresSuccess';
  constructor(public pftDocuments: PftCftObservationDocument[]) {}
}

export class GetCftDocuments {
  static readonly type = '[Explore] GetCftDocuments';
  constructor(public groupUuid: string) {}
}

export class GetCftDocumentsSuccess {
  static readonly type = '[Explore] GetCftDocumentsSuccess';
  constructor(public cftDocuments: PftCftObservationDocument[]) {}
}

export class GetIndividualCftScores {
  static readonly type = '[Explore] GetIndividualCftScores';
  constructor(public marine: User) {}
}

export class GetIndividualCftScoresSuccess {
  static readonly type = '[Explore] GetIndividualCftScoresSuccess';
  constructor(public cftDocuments: PftCftObservationDocument[]) {}
}
